export const stageRoutes = {
    register: 'Marketing Step 1',
    personal: 'Marketing Step 2',
    address: 'Marketing Step 3',
    complete: 'Marketing Complete'
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/marketing.js